import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findByList({ commit }, params) { 
		return new Promise((resolve, reject) => {
			axios.post(`/userContact/findByList`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},

	findById({ commit }, params) {  
		return new Promise((resolve, reject) => {
			axios.post(`/userContact/findById`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},

	save({ commit }, params) {  
		return new Promise((resolve, reject) => {
			axios.post(`/userContact/save`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},

	findFrequentContactsList({ commit }, params) { 
		return new Promise((resolve, reject) => {
			axios.post(`/order/findFrequentContactsList`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
				})
		})
	},

	clickIn({ commit }, params) {  
		return new Promise((resolve, reject) => {
			axios.post(`/order/updateFrequentStatus`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},

	clickOut({ commit }, params) {  
		return new Promise((resolve, reject) => {
			axios.post(`/order/updateFrequentStatus`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},

	updateFrequent({ commit }, params) {  
		return new Promise((resolve, reject) => {
			axios.post(`/order/updateFrequent`, params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
}
